import { styled } from '@mui/material/styles'
import { TabList } from '@mui/lab'

export const FormTabList = styled(TabList)({
    '.MuiTabs-indicator': {
        display: 'none',
    },
})
